import {auth} from '@/services/auth'
import _ from 'lodash'

interface IErrorReport {
  event: string
  context?: Record<string, string>
  data?: Record<string, unknown>
}
const IGNORABLE_ERROR_PATTERNS: any[] = [
  /入力された名称はすでに使われています/,
  /入力された英語表記はすでに使われています/
]

function maskSensitiveDetail(url: string) {
  // maskSensitiveDetail function is used to replace all patterns
  // matching the regular expression with the string token=****, which helps to
  // hide the value of the 'token' parameter in the URL.
  // Ex:
  //     Input:  http://domain.com/?a=b&c=d&token=abcdef&y=z
  //     Output: http://domain.com/?a=b&c=d&token=****&y=z
  // Replaces all Regular expression to match 'token=' with 'token=****'
  return url.replace(/token=[^&]*/g, 'token=****')
}

const getCircularReplacer = () => {
  // Store all seen json values to detect circular reference
  const seen = new WeakSet()
  return (key: any, value: any) => {
    // Ignore __vue__
    if (key === '__vue__') return
    if (value?._isVue) return

    // Ignore seen value
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return
      }
      seen.add(value)
    }
    return value
  }
}

export function sendErrorReport(params: IErrorReport): void {
  // If in Cypress and not enable_error_report then early return
  if ('Cypress' in window) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!(window as any).Cypress.enable_error_report) return
  }
  // Build the report message
  const jsonParams = JSON.stringify(
    {
      event: params.event,
      context: {
        timestamp: new Date().toISOString(),
        user_id: auth.me.value.user?.id || null,
        url: maskSensitiveDetail(window.location.href),
        ...(params.context || {})
      },
      data: {
        ...(params.data || {})
      }
    },
    getCircularReplacer()
  )

  // Ignore message matched predefined patterns
  if (IGNORABLE_ERROR_PATTERNS.some(pattern => pattern.test(jsonParams))) return
  navigator.sendBeacon('/public-api/errors', new Blob([jsonParams], {type: 'application/json'}))
}

export function cleanSensitiveData(data: any) {
  if (typeof data === 'object') {
    return _.cloneDeepWith(data, value => {
      value &&
        Object.keys(value).forEach(key => {
          if (key.includes('password')) {
            value[key] = '***'
          }
        })
    })
  }
  return data
}

export function getJson(text: string): string {
  try {
    return JSON.parse(text)
  } catch (e) {
    /* istanbul ignore next */
    return text
  }
}
